import { useEffect, useState } from 'react';

export const ACTION_MESSAGES = {
  CARRIERS: {
    LIFE_QUOTE: {
      SAVE: {
        type: 'success',
        message: 'Version saved successfully'
      },
      COPY: {
        type: 'success',
        message:
          "We've started the copy process. Check back in a few moments to see the new version"
      },
      DELETE: {
        type: 'success',
        message: 'Version deleted successfully'
      },
      DELETE_ERROR: {
        type: 'error',
        message: 'Unable to delete version'
      }
    },
    PRODUCT: {
      SAVE: {
        type: 'success',
        message: 'Product saved successfully'
      },
      SAVE_ERROR: {
        type: 'error',
        message: 'Unable to save Product'
      },
      DELETE: {
        type: 'success',
        message: 'Product deleted successfully'
      },
      DELETE_ERROR: {
        type: 'error',
        message: 'Unable to delete Product'
      }
    },
    VENDOR: {
      SAVE: {
        type: 'success',
        message: 'Vendor saved successfully'
      },
      DELETE: {
        type: 'success',
        message: 'Vendor deleted successfully'
      },
      DEACTIVATED: is_deactivated => ({
        type: 'success',
        message: `Vendor ${is_deactivated ? 'deactivated' : 'activated'} successfully`
      }),
      EMBEDDABLE_ETICKETS: {
        DEACTIVATED: is_deactivated => ({
          type: 'success',
          message: `E-Ticket ${is_deactivated ? 'deactivated' : 'activated'} successfully`
        })
      }
    },
    ADMIN: {
      SAVE: {
        type: 'success',
        message: 'Admin saved successfully'
      },
      DELETE: {
        type: 'success',
        message: 'Admin deleted successfully'
      },
      DELETE_ERROR: {
        type: 'error',
        message: 'Unable to delete the Admin at this time'
      }
    },
    GENERAL: {
      SAVE: {
        type: 'success',
        message: 'Carrier saved successfully'
      }
    }
  },
  DEFAULT_SUCCESS: message => ({
    type: 'success',
    message
  }),
  DEFAULT_ERROR: message => ({
    type: 'error',
    message
  }),
  DEFAULT_ERROR_WITH_DETAILS: details => ({
    type: 'error',
    message: 'Oops! Something went wrong',
    details
  }),
  DEFAULT_INFO: message => ({
    type: 'info',
    message
  }),
  NULL_MESSAGE: {
    type: null,
    message: ''
  }
};

export const useNotification = ({ type, message }) => {
  const [notification, setNotification] = useState({
    type,
    message
  });

  useEffect(() => {
    if (notification.message === '' || notification.type === null) {
      return () => {};
    }

    const messageTimer = setTimeout(() => {
      setNotification({ type: null, message: '' });
    }, 10000);

    return () => clearTimeout(messageTimer);
  }, [notification]);

  return {
    notification,
    setNotification
  };
};
